import { SavedSearch } from '@/data/SavedSearchApi/SavedSearchApi';
import { FiltersPayloadRow } from '@/types/CarFilters.types';

export const handleSavedSearchApiUpdatesViaProxy = async (
  plpSlug: string,
  options: {
    savedSearch?: SavedSearch | null;
    filters?: FiltersPayloadRow[];
    isSimilarTo?: string | null;
    isActive?: boolean;
    typesenseQuery?: string;
  } = {},
) => {
  const { savedSearch = null, filters = [], isSimilarTo = null, isActive = false, typesenseQuery = '' } = options;

  const res = await fetch('/api/save-searches', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ savedSearch, isActive, filters, isSimilarTo, plpSlug, typesenseQuery }),
  });
  return res.json();
};
